import {
  type ParticipantDocument,
  type ParticipantDocumentStatus,
  renderParticipantDocumentStatus,
} from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { createModal } from '../../components/generic/Modal';
import { useUpdateParticipantDocumentMutation } from '../../graphql/hooks/useUpdateParticipantDocumentMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantDocument: ParticipantDocument;
  status: ParticipantDocumentStatus;
}

export const ParticipantDocumentChangeStatusModal = createModal<Props>((props) => {
  const { visible, hide, remove } = props.modal;

  const { participantDocument, status } = props;
  const { organization, errorToast, successToast } = useAppContext();
  const mutation = useUpdateParticipantDocumentMutation();

  const onClick = async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId: participantDocument.participantId,
        participantDocumentId: participantDocument.id,
        request: {
          status,
        },
      })
      .then(() => {
        successToast('Participant document status updated');
        hide();
      })
      .catch((err) => {
        errorToast(`Error updating participant document status: ${err.message}`);
      });
  };

  return (
    <ChakraV3.Dialog.Root open={visible} onOpenChange={hide} onExitComplete={remove}>
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.DialogTitleSubtitle
            title={`Do you want to change the status from ${renderParticipantDocumentStatus(participantDocument.status)} to ${renderParticipantDocumentStatus(status)}?`}
          />
          <ChakraV3.Dialog.Body>
            <ChakraV3.Stack gap={4}>
              <ChakraV3.AlertBanner status='success' title='There were no issues found' />
              Are you sure you want to continue?
            </ChakraV3.Stack>
          </ChakraV3.Dialog.Body>
          <ChakraV3.Dialog.Footer>
            <ChakraV3.HStack>
              <ChakraV3.Button key='close' onClick={hide} variant='subtle' size='sm'>
                Close
              </ChakraV3.Button>
              <ChakraV3.Button
                loading={mutation.isLoading}
                loadingText='Updating status...'
                colorPalette='brand'
                onClick={onClick}
                size='sm'
              >
                Update
              </ChakraV3.Button>
            </ChakraV3.HStack>
          </ChakraV3.Dialog.Footer>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
